export enum LikeDislike {
  LIKE = 'LIKE',
  DISLIKE = 'DISLIKE',
}
